import { uuid } from 'codekit';

import * as Icons from 'icons';
import { Faq, FaqQuestion } from 'models/Faq';

export const faqQuestions: FaqQuestion[] = [
	{
		id: uuid(),
		category: 'pricing',
		question: 'Quais são os preços para os serviços oferecidos?',
		answer: 'Os preços podem variar dependendo do escopo e complexidade do projeto. Recomendamos entrar em contato conosco com informações detalhadas sobre suas necessidades para que possamos fornecer um orçamento personalizado e competitivo.',
	},
	{
		id: uuid(),
		category: 'pricing',
		question: 'Quanto tempo leva para entregar um projeto?',
		answer: 'O prazo de entrega pode variar dependendo da complexidade do projeto e dos requisitos específicos. Procuramos trabalhar de forma eficiente para entregar os projetos dentro dos prazos acordados. Após uma análise inicial do seu projeto, poderemos fornecer uma estimativa mais precisa do tempo necessário para a conclusão.',
	},
	{
		id: uuid(),
		category: 'pricing',
		question:
			'Posso obter um orçamento sem compromisso para o meu projeto?',
		answer: 'Sim, você pode nos fornecer detalhes do seu projeto e solicitar um orçamento sem compromisso. Estamos disponíveis para analisar suas necessidades e fornecer uma cotação justa e personalizada.',
	},
	{
		id: uuid(),
		category: 'pricing',
		question: 'Existem custos adicionais que devo estar ciente?',
		answer: 'Em geral, nossos orçamentos abrangem todos os custos associados ao projeto. No entanto, em casos excepcionais, podem surgir custos adicionais, mas sempre informaremos claramente antes de qualquer trabalho adicional ser iniciado.',
	},
	{
		id: uuid(),
		category: 'pricing',
		question: 'Vocês aceitam pagamentos parcelados?',
		answer: 'Sim, oferecemos opções de pagamento parcelado para projetos maiores. Fale conosco para discutir as possibilidades e encontraremos uma solução adequada às suas necessidades.',
	},
	{
		id: uuid(),
		category: 'process',
		question: 'Como funciona o processo de trabalho?',
		answer: 'Nosso processo de trabalho envolve uma análise inicial das necessidades do cliente, criação de um conceito, desenvolvimento do design, codificação e implementação do projeto. Estamos abertos a colaboração durante todas as etapas para garantir sua satisfação.',
	},
	{
		id: uuid(),
		category: 'process',
		question: 'Eu serei envolvido no desenvolvimento do projeto?',
		answer: 'Sim, acreditamos na importância da colaboração com nossos clientes. Você será parte integrante do processo e terá oportunidades para fornecer feedback e revisar o progresso do projeto.',
	},
	{
		id: uuid(),
		category: 'process',
		question: 'Qual é a duração típica do processo de desenvolvimento?',
		answer: 'A duração do processo de desenvolvimento pode variar, dependendo da complexidade do projeto. Procuramos manter uma abordagem ágil, mas garantindo a qualidade do trabalho realizado.',
	},
	{
		id: uuid(),
		category: 'process',
		question: 'Vocês fazem atualizações do projeto após a entrega final?',
		answer: 'Sim, após a entrega final, podemos realizar atualizações e ajustes conforme necessário. Queremos garantir que o projeto atenda plenamente aos seus requisitos.',
	},
	{
		id: uuid(),
		category: 'process',
		question: 'Como posso acompanhar o progresso do projeto?',
		answer: 'Manteremos você informado sobre o andamento do projeto em cada etapa do processo. Além disso, estaremos disponíveis para discutir qualquer dúvida ou preocupação que você possa ter.',
	},
	{
		id: uuid(),
		category: 'technologies',
		question:
			'Quais tecnologias vocês utilizam para desenvolver os projetos?',
		answer: 'Trabalhamos com uma ampla variedade de tecnologias, incluindo HTML, CSS, JavaScript puro, React, Next.js, Firebase e muitas outras. Utilizamos as ferramentas e tecnologias mais adequadas para cada projeto específico, levando em consideração os requisitos e objetivos do cliente.',
	},
	{
		id: uuid(),
		category: 'technologies',
		question:
			'Vocês desenvolvem sites responsivos e compatíveis com dispositivos móveis?',
		answer: 'Sim, todos os nossos projetos são desenvolvidos levando em consideração a experiência do usuário em dispositivos móveis e garantindo a responsividade do site em diferentes tamanhos de tela.',
	},
	{
		id: uuid(),
		category: 'technologies',
		question: 'Posso sugerir tecnologias específicas para o meu projeto?',
		answer: 'Certamente! Se você tiver preferências específicas em relação às tecnologias a serem utilizadas, ficaremos felizes em ouvir suas sugestões e adaptar o desenvolvimento de acordo.',
	},
	{
		id: uuid(),
		category: 'technologies',
		question:
			'Vocês fornecem serviços de hospedagem e registro de domínio?',
		answer: 'Não fornecemos serviços de hospedagem e registro de domínio diretamente, mas podemos orientá-lo na escolha de provedores confiáveis e auxiliar na configuração, se necessário.',
	},
	{
		id: uuid(),
		category: 'technologies',
		question:
			'Como é feita a segurança dos projetos desenvolvidos por vocês?',
		answer: 'A segurança é uma prioridade em nossos projetos. Implementamos boas práticas de segurança e proteção de dados para garantir a integridade e confidencialidade das informações do cliente.',
	},
];

export const faq: Faq = {
	pricing: {
		category: 'pricing',
		label: 'Preços e Orçamento',
		questions: faqQuestions.filter((q) => q.category === 'pricing'),
	},
	process: {
		category: 'process',
		label: 'Desenvolvimento',
		questions: faqQuestions.filter((q) => q.category === 'process'),
	},
	technologies: {
		category: 'technologies',
		label: 'Tecnologias',
		questions: faqQuestions.filter((q) => q.category === 'technologies'),
	},
};

export const faqVariants = {
	container: {
		hidden: { opacity: 1 },
		visible: {
			opacity: 1,
			transition: {
				// delay to start
				delayChildren: 0.1,

				// damping between elements
				staggerChildren: 0.1,
			},
		},
	},
	item: {
		hidden: {
			y: 20,
			opacity: 0,
		},
		visible: {
			y: 0,
			opacity: 1,
		},
	},
};

export const ourNumbers = [
	{
		value: 12147.2,
		label: 'Horas trabalhadas em projetos',
	},
	{
		value: 193,
		label: 'Projetos inovadores desenvolvidos',
	},
	{
		value: 9766,
		label: 'Pessoas atingidas com as nossas soluções',
	},
	{
		value: 99,
		suffix: '%',
		label: 'Disponibilidade em nossos sites e aplicativos',
	},
];

export const howItWorksSteps = [
	{
		id: 1,
		ref: 'one',
        slug: 'analysis',
		name: 'Análise',
		shortName: 'Análise',
		description: `Compreender as necessidades dos clientes e identificar oportunidades para oferecer melhores soluções.`,
		icon: Icons.StepsAnalysisIcon,
	},
	{
		id: 2,
		ref: 'two',
        slug: 'design',
		name: 'Design',
		shortName: 'Design',
		description: `Criar interfaces atraentes e
            intuitivas por meio de protótipos
            interativos.`,
		icon: Icons.StepsDesignIcon,
	},
	{
		id: 3,
		ref: 'three',
        slug: 'development',
		name: 'Desenvolvimento',
		shortName: 'Código',
		description: `Transformar ideias em software
        funcional e eficiente, utilizando
        tecnologias de ponta.`,
		icon: Icons.StepsCodeIcon,
	},
	{
		id: 4,
		ref: 'four',
        slug: 'testing',
		name: 'Testes',
		shortName: 'Testes',
		description: `Garantir a qualidade e
        estabilidade do software por
        meio de testes rigorosos e
        correções iterativas.`,
		icon: Icons.StepsCodeIcon,
	},
].slice(0, 4);
